import { deserialize, serialize } from "serializr";

import _axiosInstance from "../../interceptor/_axiosInstance";
import axiosInstance from "../../interceptor/axiosInstance";

import { ExamModel } from "../../models/ExamModels/exam.model";
import { FilterLeaderboard, Leaderboard, SectionSubjects } from "../../models/LeaderboardModel/Leaderboard.model";
import { PaginationModel } from "../../models/PaginationModel/pagination.model";
import { EXAMS_META, LEADERBOARD_CLASSROOM_BYINST, LEADERBOARD_CLASSROOM_BYONBOARD, LEADERBOARD_EXAM, SECTION_SUBJECTS } from "../../routes/routeConstants/apiRoutes";
import { defaultFilterLeaderboard } from "../../shared/utils/filter";
export default class LeaderboardService {
    static fetchLearderboardByInst(
        data: FilterLeaderboard,
        onSuccess: (value: Leaderboard[], meta: PaginationModel) => void,
        onError: Function,
        onFinal: () => void
    ) {
        const payload = serialize(FilterLeaderboard, {...defaultFilterLeaderboard,...data})
        return _axiosInstance.get(LEADERBOARD_CLASSROOM_BYINST, { params: payload })
            .then(response => {
                const data = deserialize(Leaderboard, response["data"]?.["leaders"])
                const meta = deserialize(PaginationModel, response["data"]?.["meta"])
                onSuccess(data as Leaderboard[], meta)
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }
    static fetchLearderboardByOnboard(
        data: FilterLeaderboard,
        onSuccess: (value: Leaderboard[], meta: PaginationModel) => void,
        onError: Function,
        onFinal: () => void
    ) {
        const payload = serialize(FilterLeaderboard, {...defaultFilterLeaderboard,...data})
        return _axiosInstance.get(LEADERBOARD_CLASSROOM_BYONBOARD, { params: payload })
            .then(response => {
                const data = deserialize(Leaderboard, response["data"]?.["leaders"])
                const meta = deserialize(PaginationModel, response["data"]?.["meta"])
                onSuccess(data as Leaderboard[], meta)
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }
    static fetchExamLeaderboard(
        data: FilterLeaderboard,
        onSuccess: (value: Leaderboard[], meta: PaginationModel) => void,
        onError: Function,
        onFinal: () => void
    ) {
        const payload = serialize(FilterLeaderboard, data)
        return axiosInstance.get(
            LEADERBOARD_EXAM, { params: payload }
        )
            .then(response => {
                const data = deserialize(Leaderboard, response["data"]?.["student_leaderboard"])
                const meta = deserialize(PaginationModel, response["data"]?.["meta"])
                onSuccess(data as Leaderboard[], meta)
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }

    // old code   
    static fetchSectionSubjects(
        sectionId: number,
        onSuccess: (value: SectionSubjects[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance.get(
            SECTION_SUBJECTS, {
            params: {
                section_id: sectionId
            }
        }
        )
            .then(response => {
                const data = deserialize(SectionSubjects, response["data"]?.["section_subjects"])
                onSuccess(data as SectionSubjects[])
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }
    // -----------------

    static fetchExamsMeta(
        onSuccess: (value: ExamModel[]) => void,
        onError: Function,
        onFinal: () => void
    ) {
        return axiosInstance.get(EXAMS_META)
            .then(response => {
                const data = deserialize(ExamModel, response["data"]?.["exams"])
                onSuccess(data as ExamModel[])
            })
            .catch(error => {
                onError(error)
            })
            .finally(onFinal)
    }



}   